module.exports = __webpack_public_path__ + "static/media/14.043401f0.jpg";